import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { useAuth } from '../auth/AuthContext';
import { updateProfile } from '../api/auth';
import PageHeader from '../components/layout/PageHeader';
import Card from '../components/ui/Card';
import Input from '../components/ui/Input';
import Button from '../components/ui/Button';
import { pushToast } from '../components/ui/toastBus';

export default function Profile() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || '');
  const [phone, setPhone] = useState(user?.phone || '');
  const [currentPassword, setCurrentPassword] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [errors, setErrors] = useState({});

  const mutation = useMutation({
    mutationFn: (payload) => updateProfile(payload),
    onSuccess: async () => {
      pushToast({ type: 'success', message: 'Profile updated.' });
      setCurrentPassword('');
      setPassword('');
      setPasswordConfirmation('');
      setErrors({});
      await refresh();
    },
    onError: (err) => {
      setErrors(err.response?.data?.errors || {});
    },
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { name, phone };
    if (password) {
      payload.current_password = currentPassword;
      payload.password = password;
      payload.password_confirmation = passwordConfirmation;
    }
    mutation.mutate(payload);
  };

  const fieldError = (field) => errors[field]?.[0];

  return (
    <div>
      <PageHeader title="Profile" description="Update your account details." />

      <Card className="max-w-lg">
        <form onSubmit={handleSubmit} className="space-y-4">
          <Input label="Name" value={name} onChange={(e) => setName(e.target.value)} error={fieldError('name')} />
          <Input
            label="Phone"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            error={fieldError('phone')}
          />

          <div className="border-t border-gray-100 pt-4">
            <h3 className="text-sm font-medium text-gray-900 mb-3">Change password</h3>
            <div className="space-y-4">
              <Input
                label="Current password"
                type="password"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                error={fieldError('current_password')}
              />
              <Input
                label="New password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                error={fieldError('password')}
              />
              <Input
                label="Confirm new password"
                type="password"
                value={passwordConfirmation}
                onChange={(e) => setPasswordConfirmation(e.target.value)}
              />
            </div>
          </div>

          <Button type="submit" loading={mutation.isPending}>
            Save changes
          </Button>
        </form>
      </Card>
    </div>
  );
}
